export const API_ORIGIN =
  import.meta.env.VITE_API_ORIGIN ||
  (import.meta.env.DEV ? 'http://localhost:3000' : window.location.origin);

export const API_ROOT_URL = import.meta.env.VITE_API_ROOT_URL || `${API_ORIGIN}/api`;
export const API_V1_BASE_URL = import.meta.env.VITE_API_BASE_URL || `${API_ORIGIN}/api/v1`;
export const S3_API_BASE_URL = import.meta.env.VITE_S3_API_BASE_URL || `${API_ORIGIN}/api/s3`;
